import { toastError } from '@onestep/coreui/Toast';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import useCurrentClinic from '../../hooks/useCurrentClinic';
import useMixpanel from '../../hooks/useMixpanel';
import useStores from '../../hooks/useStores';
import { useTutorialActions } from './tutorialActions';
import type { ITutorialEvent, tourTypeEnum } from './types';

export const useWebTutorialService = () => {
  const { webTutorialStore } = useStores();
  const { clinic } = useCurrentClinic();
  const { track } = useMixpanel();
  const tutorialActions = useTutorialActions();

  const { data, isError, error, isLoading } = useQuery<{
    result: ITutorialEvent[];
  }>({
    queryKey: ['camel', 'tutorial', 'list', { clinicUuid: clinic?.uuid }],
    enabled: !!clinic?.uuid,
  });

  useEffect(() => {
    if (isError) {
      toastError({ content: 'Failed to load tutorial list' });
      track('failed_get_tutorial_list', {
        error,
      });
    }
  }, [isError]);

  return {
    data: data?.result ?? ([] as ITutorialEvent[]),
    ...tutorialActions,
    checkIfNeedTutorial: (tourType: tourTypeEnum) =>
      !data?.result?.some((event) => event?.action?.includes(tourType)),
    state: webTutorialStore,
    isTutorialListLoading: !!clinic?.uuid && isLoading,
  };
};
